import { render, staticRenderFns } from "./JSelectRole.vue?vue&type=template&id=24ad3162&scoped=true"
import script from "./JSelectRole.vue?vue&type=script&lang=js"
export * from "./JSelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad3162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ad3162')) {
      api.createRecord('24ad3162', component.options)
    } else {
      api.reload('24ad3162', component.options)
    }
    module.hot.accept("./JSelectRole.vue?vue&type=template&id=24ad3162&scoped=true", function () {
      api.rerender('24ad3162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectRole.vue"
export default component.exports